/**
 * Utility functions for API data handling and normalization
 */

/**
 * Converts snake_case keys in an object to camelCase
 * This function recursively processes objects and arrays
 * 
 * @param {Object|Array|*} obj - The object or array to convert
 * @returns {Object|Array|*} - The converted object or array
 */
export function snakeToCamel(obj) {
  if (obj === null || typeof obj !== 'object') return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(snakeToCamel);
  }
  
  return Object.keys(obj).reduce((result, key) => {
    // Convert key from snake_case to camelCase
    const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    
    // Convert value recursively if it's an object
    result[camelKey] = snakeToCamel(obj[key]);
    return result;
  }, {});
}

/**
 * Converts camelCase keys in an object to snake_case
 * This function recursively processes objects and arrays
 * 
 * @param {Object|Array|*} obj - The object or array to convert
 * @returns {Object|Array|*} - The converted object or array
 */
export function camelToSnake(obj) {
  if (obj === null || typeof obj !== 'object') return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(camelToSnake);
  }
  
  return Object.keys(obj).reduce((result, key) => {
    // Convert key from camelCase to snake_case
    const snakeKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    
    // Convert value recursively if it's an object
    result[snakeKey] = camelToSnake(obj[key]);
    return result;
  }, {});
}
